
import React from 'react';

import './Wrapper-v-fmt-player.css';

class Wrapper_v_fmt_player extends React.Component {

  static get div_id() { return 'v-app'; }
  static get params() {
    return {
      ':player-site-data': 'playerSiteData',
      ':contextmenu-u-i': 'contextmenuUI',
    };
  }

  render() {
    return (
      <div id={Wrapper_v_fmt_player.div_id} className='wrapper-v-fmt-player-container'>
        <v-fmt-player {...Wrapper_v_fmt_player.params}></v-fmt-player>
      </div>
    );
  }

  componentDidMount() {
    window.createPlayer( `#${Wrapper_v_fmt_player.div_id}`, this.props.fmt_playerConfiguration);
  }

}

export default Wrapper_v_fmt_player;
